import * as React from 'react';
const SvgIcoSpotAIntegrer = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    viewBox='0 0 200 200'
    {...props}
  >
    <style>
      {
        '.ICO_SpotAIntegrer_N_svg__st0{display:none}.ICO_SpotAIntegrer_N_svg__st1{display:inline}.ICO_SpotAIntegrer_N_svg__st2{fill:#7984ba}.ICO_SpotAIntegrer_N_svg__st3,.ICO_SpotAIntegrer_N_svg__st4{fill-rule:evenodd;clip-rule:evenodd}.ICO_SpotAIntegrer_N_svg__st4{fill:#7984ba}'
      }
    </style>
    <path
      id='ICO_SpotAIntegrer_N_svg__Calque_13'
      d='M118.37 71.92H97.12c-1.79 0-3.2 1.41-3.2 3.2v2.56h-4.99c-1.79 0-3.2 1.41-3.2 3.2v27.4c0 1.79 1.41 3.2 3.2 3.2h27.4c1.79 0 3.2-1.41 3.2-3.2v-2.56h4.99c1.79 0 3.2-1.41 3.2-3.2V80.75zm-18.95 29.96c-.25.26-.64.38-.9.38s-.64-.13-.9-.38c-.51-.51-.51-1.28 0-1.79l8.58-8.58h-5.12c-.77 0-1.28-.64-1.28-1.28 0-.77.64-1.28 1.28-1.28h8.19c.13 0 .38 0 .51.13.26.13.51.38.64.64.13.13.13.38.13.51v8.19c0 .77-.64 1.28-1.28 1.28s-1.28-.64-1.28-1.28V93.3zm19.46-28.81 7.56 7.17h-4.87c-1.41 0-2.69-1.15-2.69-2.69zm-1.4 35.21c0 .64-.51 1.02-1.03 1.02H88.92c-.64 0-1.02-.51-1.02-1.02v-27.4c0-.64.51-1.02 1.02-1.02h4.99v22.66c0 1.79 1.41 3.2 3.2 3.2h20.36v2.56z'
    />
  </svg>
)
export default SvgIcoSpotAIntegrer

